import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useMutation, useQuery} from "react-query";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {AdminBankSwiftCodeForm} from "Views/BankSwiftCodes/AdminBankSwiftCodeForm";
import {getBankSwiftCodeDetail} from "Api/Query/BankSwiftCodeQuery";
import {updateBankSwiftCode} from "Api/Mutation/BankSwiftCodeMutation";

export const AdminBankSwiftCodeEdit: React.FC = () => {

    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [entity, setEntity] = useState<any>({bank_code: '', bic: '', bank: ''});

    const update = useMutation({
        mutationKey: ['updateBankSwiftCode'],
        mutationFn: (body: any) => updateBankSwiftCode(id ?? '', {bic: body.bic, bank: body.bank}),
        onSuccess: () => {
            Notificator.success('El código SWIFT se ha actualizado correctamente');
            navigate(ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_LIST);
        },
        onError: () => {
            Notificator.error('Se ha producido un error al actualizar el código SWIFT');
        }
    });

    const query = useQuery({
        enabled: false,
        queryKey: ['getBankSwiftCodeDetail', id],
        queryFn: () => getBankSwiftCodeDetail(id ?? '-1'),
        onSuccess: (response: any) => {
            const result = response?.data?._result ?? response?.data?.data;
            setEntity(result);
        },
        onError: () => {
            Notificator.error('Se ha producido un error al cargar los datos.');
        }
    });

    useEffect(() => {
        query.refetch();
    }, []);

    useEffect(() => {
        dispatch(appLoading({value: query.isLoading, text: 'Cargando'}));
    }, [query.isLoading]);

    useEffect(() => {
        dispatch(appLoading({value: query.isRefetching, text: 'Cargando'}));
    }, [query.isRefetching]);

    useEffect(() => {
        dispatch(appLoading({value: update.isLoading, text: 'Cargando'}));
    }, [update.isLoading]);

    return (
        <RequireAuth>
            <DefaultContainer>
                <Col>
                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Editar código SWIFT</h1>
                        </Col>
                    </Row>
                    <Row>
                        <AdminBankSwiftCodeForm
                            onSave={(data) => update.mutate(data)}
                            data={entity}
                            isEdit={true}
                        />
                    </Row>
                </Col>
            </DefaultContainer>
        </RequireAuth>
    );
};
